import dayjs, { Dayjs } from "dayjs"
import { LanguageDict } from "../types"

export default class Faq {

    public id: string
    public questionFr: boolean
    public questionEn: string
    public answerFr: string
    public answerEn: string
    public createdAt: Dayjs

    constructor(data: any) {
        this.id = data.reference
        this.questionFr = data.questionFr
        this.questionEn = data.questionEn
        this.answerFr = data.answerFr
        this.answerEn = data.answerEn
        this.createdAt = dayjs(data.createdAt)
    }

    getQuestion = (locale: LanguageDict): string => {
        // @ts-ignore
        return this[`question${locale[0].toUpperCase()}${locale.substring(1)}`]
    }

    getAnswer = (locale: LanguageDict): string => {
        // @ts-ignore
        return this[`answer${locale[0].toUpperCase()}${locale.substring(1)}`]
    }
}
